import React from "react";
import styled from "styled-components";
import { colors } from "utils";
import { SelectDropdown } from "components/shared/FilterDropdowns/FilterDropdowns";

// Section heading above a listing (Figma 3987-14626) — e.g. "Lessons", the
// sibling of the "Quick Groups" title. ABC Marfa, 20px, semibold, green.
export const ListingTitle = styled.h2`
  color: #002e19;
  font-family: "ABC Marfa", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin: 0 0 24px;
`;

// Title + Sort By on one row, both left-aligned. No bottom margin: the row is
// rendered as the first child of its listing's gap-24 stack.
const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
`;

const HeaderTitle = styled(ListingTitle)`
  margin: 0;
`;

// "Sort By" sits beside the select rather than above it, so the label is
// rendered here and the dropdown is named with ariaLabel instead. Its own label
// is block-level and would stack.
const SortGroup = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
`;

const SortLabel = styled.span`
  color: ${colors.nightlyWoods950};
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
`;

const SortWrap = styled.div`
  width: 200px;
`;

// Shared listing header: the section title, plus a Sort By dropdown when the
// listing offers one. Used by Quick Groups and by the Lessons listing in both
// the differentiation (v1) and lesson-picker (v2) views.
export const ListingHeader = ({ title, sortValue, sortOptions, onSortChange }) => (
  <HeaderRow>
    <HeaderTitle>{title}</HeaderTitle>
    {sortOptions?.length > 0 && (
      <SortGroup>
        <SortLabel>Sort By</SortLabel>
        <SortWrap>
          <SelectDropdown
            ariaLabel="Sort By"
            value={sortValue}
            displayText={sortOptions.find((o) => o.value === sortValue)?.label}
            options={sortOptions}
            onChange={onSortChange}
          />
        </SortWrap>
      </SortGroup>
    )}
  </HeaderRow>
);
